import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Loading, RoundedPaper } from '../../../lib/components';
import { CardWidget } from '../../../lib/components/compound/surfaces/cardWidget';
import { LoadingProps } from '../../partials/basePage';
import { LaunchIcon } from '../../../lib/icons';

type Props = {
  icon?: JSX.Element;
  title: string;
  description: string;
  percentValue: number;
  onFooterClicked?: () => void;
} & LoadingProps;

export type BenefitMiXCardProps = Props;

export const BenefitMixCard: FC<Props> = ({
  icon,
  title,
  description,
  percentValue,
  onFooterClicked,
  isLoading
}) => {
  const { t } = useTranslation();

  const openBenefitPage = () => {
    const path = title == 'ÖPNV-Tickets' ? 'oepnv-ticket' : title.toLowerCase();
    window.open(`https://pxtra.de/benefits/${path}`, '_blank');
  };

  return (
    <CardWidget
      footerText={onFooterClicked !== undefined ? t('common:LEARN_MORE') : undefined}
      onFooterClicked={onFooterClicked}
      sx={{
        backgroundColor: 'heaven.main',
        color: 'common.white',
        textAlign: 'center',
        paddingX: '1rem',
        paddingY: '1rem',
        '& button > p': {
          color: 'common.white'
        }
      }}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {icon && icon}
          <Typography variant="subtitle2" fontSize="1rem" color="inherit">
            {title}
          </Typography>
          <Typography variant="body2" color="inherit">
            {description}
          </Typography>
          <RoundedPaper
            sx={{
              backgroundColor: 'common.white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.25rem',
              padding: '0.5rem 0.875rem',
              marginTop: '1rem'
            }}
          >
            <Typography
              variant="h1"
              component="span"
              lineHeight="2rem"
              color="heaven.main"
              fontWeight="bold"
              whiteSpace="nowrap"
            >{`${percentValue} %`}</Typography>
            <Typography
              variant="caption"
              align="left"
              width="50%"
              paddingLeft=".25rem"
              lineHeight=".75rem"
            >
              {t('common:ARE_INTERESTED')}
            </Typography>
          </RoundedPaper>
          <Box
            textAlign="center"
            alignItems="center"
            justifyContent="center"
            marginTop="0.75rem"
            onClick={openBenefitPage}
          >
            <Typography
              variant="caption"
              lineHeight="0.75rem"
              color="common.white"
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {t('common:LEARN_MORE')}
              <LaunchIcon sx={{ fontSize: '1.1rem', marginLeft: '0.25rem' }} />
            </Typography>
          </Box>
        </>
      )}
    </CardWidget>
  );
};
